import { VNode } from "vue";

/**
 * 创建表单项
 * @param label 标签名
 * @param key 绑定key
 * @param el 表单项类型
 * @param props 表单项属性
 * @param options 表单选择项
 * @param labelKey 表单选择项显示key
 * @param valueKey 表单选择项值的key
 */
export function createFormItem(
  label: string,
  key: string,
  el: string | Element | VueComponent | ((value: Ref<{ [key: string]: any }>) => VNode),
  props?: any,
  options?: { [key: string]: string }[],
  labelKey?: string,
  valueKey?: string
  ): FormItem 
  {
  return {
    key,
    label,
    el,
    props,
    options,
    labelKey,
    valueKey
  }
}